module.exports = __webpack_public_path__ + "img/brasil_1.7d237ec1.jpg";